import React from 'react';
// eslint-disable-next-line
import { QRCodeCanvas } from 'qrcode.react';

const QRCodeComponent = ({ url, size = 160 }) => (
    <div>
      <QRCodeCanvas value={url} size={size} level="H" />
    </div>
  );
export default QRCodeComponent;
